import { render } from "./BoardColumnEditor.vue?vue&type=template&id=e067b41e&scoped=true"
import script from "./BoardColumnEditor.vue?vue&type=script&lang=js"
export * from "./BoardColumnEditor.vue?vue&type=script&lang=js"

import "./BoardColumnEditor.vue?vue&type=style&index=0&id=e067b41e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e067b41e"]])

export default __exports__